import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCranes } from "../../repositories/CraneRepository";
import { useCraneContext } from "./CraneContext";
import { TableCrane } from "./components/TableCrane";

type Props = {};
export const CranePage = (props: Props) => {
  const { actions } = useCraneContext();
  const { craneCode } = useParams();

  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const getCranesFromAPI = async () => {
    setIsLoading(true);
    const resp = await getCranes();
    if (resp.ok) {
      const cranes = get(resp, "data.tables[0].rows", []);
      actions.setCranes(cranes);
      setIsLoading(false);
    } else {
      setError(resp.message);
    }
  };

  useEffect(() => {
    getCranesFromAPI();
  }, []);

  return (
    <>
      <HelmetDexteel title={"Cranes"} />
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={12} xs={12} style={{ margin: 0 }}>
          <Paper
            elevation={1}
            style={{
              width: "100%",
              padding: "10px 0 20px",
              borderRadius: "0.75rem",
              height: "auto",
            }}
          >
            <TableCrane
              craneCode={craneCode}
              isLoading={isLoading}
              refetch={getCranesFromAPI}
            />
          </Paper>
        </Grid>
      </Grid>
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
